// extracted by mini-css-extract-plugin
export default {"link":"Header_link__f7A2d","heading":"Header_heading__LjpU9"};